<div class="insured">
  <div class="insured-column">
    <div class="insured-name" appConfigSettingsInput>
      <div>
        <app-initials-component
          placeholder="Insured.Initials"
          [control]="insuredFormGroup.get('initials')"
          [form]="insuredFormGroup"
        ></app-initials-component>
      </div>
      <div>
        <app-text-input
          class="full-width"
          placeholder="Insured.MiddleName"
          [control]="insuredFormGroup.get('middleName')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
        ></app-text-input>
      </div>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Surname"
        [control]="insuredFormGroup.get('surname')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
        capitalize="true"
      ></app-text-input>
    </div>
    <div class="insured-gender-container">
      <app-toggle-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Gender"
        [form]="insuredFormGroup"
        [optionsList]="genderList"
        [control]="insuredFormGroup.get('gender')"
        [formSubmitted]="true"
      ></app-toggle-input>
    </div>
    <div class="insured-address">
      <div
        class="insured-address-zipCode"
        appConfigSettingsInput
      >
        <app-text-input
          class="full-width"
          appConfigSettingsInput
          placeholder="Insured.ZipCode"
          [control]="insuredFormGroup.get('zipCode')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
          inputMask="0000 SS"
          [dropSpecialCharacters]="false"
          uppercase="true"
        ></app-text-input>
      </div>
      <div
        class="insured-address-houseNumber"
        appConfigSettingsInput
      >
        <app-text-input
          class="full-width"
          placeholder="Insured.HouseNumber"
          [control]="insuredFormGroup.get('houseNumber')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
          type="number"
          [isLoaderShown]="isZipCodeLoaderShown"
        ></app-text-input>
      </div>
      <div
        class="insured-address-houseNumberSuffix"
        appConfigSettingsInput
      >
        <app-text-input
          class="full-width"
          placeholder="Insured.HouseNumberSuffix"
          [control]="insuredFormGroup.get('houseNumberSuffix')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
        ></app-text-input>
      </div>
      <div
        class="insured-address-message"
        *ngIf="isEmptyZipCodeServiceResultMessageShown"
      >
        {{ "Common.PostCodeAddressNotFound" | translate }}
      </div>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Street"
        [control]="insuredFormGroup.get('street')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
      ></app-text-input>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.City"
        [control]="insuredFormGroup.get('city')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
      ></app-text-input>
    </div>
  </div>

  <div class="insured-column">
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.MobilePhoneNo"
        [control]="insuredFormGroup.get('mobilePhoneNo')"
        [form]="insuredFormGroup"
        [pattern]="phonePattern"
        [inputMask]="phoneMask"
        showPlaceholder="false"
        prefix="+31 (0)"
        dropSpecialCharacters="true"
      ></app-text-input>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.EmailAddress"
        [control]="insuredFormGroup.get('emailAddress')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
        isRequiredMessageKey="Insured.EmailConfirmationIsRequiredMessage"
      ></app-text-input>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.SecondEmailAddress"
        [control]="insuredFormGroup.get('confirmedEmailAddress')"
        [form]="insuredFormGroup"
        additionalInfoInsurer="AdditionalInformation.ConfirmEmail"
        showPlaceholder="false"
      ></app-text-input>
    </div>
    <div>
      <app-autocomplete-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Nationality"
        [form]="insuredFormGroup"
        [control]="insuredFormGroup.get('nationality')"
        [dataSource]="countryList"
        showPlaceholder="false"
        [fontColor]="configSettings.fontColor"
        [fontFamily]="FontTypeEnum[configSettings.fontType]"
      ></app-autocomplete-input>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Iban"
        [control]="insuredFormGroup.get('iban')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
        [inputMask]="ibanMask"
        uppercase="true"
      ></app-text-input>
    </div>
  </div>
</div>
